// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"d5bc7771","355":"b9313095","382":"7a95a66d","534":"fe740a8f","778":"ae8c49bc"}[chunkId] + ".chunk.css";
};